import { detectIsInIframe } from '../../../utils/detect-is-in-frame';

export class UserActivityTracker {
  private ACTIVITY_KEY: string;

  constructor() {
    this.ACTIVITY_KEY = 'lastActivityUnixMilli';
  }

  private getLastActivityDate(): Date | null {
    try {
      const timestamp = globalThis.localStorage?.getItem(this.ACTIVITY_KEY);
      return timestamp ? new Date(Number(timestamp)) : null;
    } catch (err) {
      console.error('Failed to fetch activity date:', err);
      return null;
    }
  }

  updateActivityToNow() {
    try {
      globalThis.localStorage?.setItem(this.ACTIVITY_KEY, Date.now().toString());
    } catch (err) {
      console.error('Failed to update activity date:', err);
    }
  }

  hasPreviousActivity(): boolean {
    const lastActivity = this.getLastActivityDate();
    return Boolean(lastActivity);
  }

  lastActivityOlderThanHours(hours: number): boolean {
    // When we are in an iframe, we want the manager app to control
    // when child windows should expire, so we don't want to expire
    // them based on their own activity, which is started by using the login page
    if (detectIsInIframe()) {
      return false; // Don't expire child windows
    }

    const lastActivity = this.getLastActivityDate();
    if (!lastActivity) return false; // technically correct

    const limit = Date.now() - hours * 60 * 60 * 1000;
    return lastActivity.getTime() < limit;
  }
}
